(function (angular, app) {
    'use strict';

    app.directive('productActions', ['Util', function (util) {
        return {
            restrict: 'E',
            templateUrl: 'template/directives/product-actions/index.html',
            replace: true,
            scope: {
                mode: '@', // landscape/portrait
                product: '=',
                line: '=?',
                isCase: '=?',
                isPack: '=?',
                removeFromCart: '=',
                text: '@',  // only in landscape mode
                hideCart: '@',
                estText: '@',
                productPropertyValue: '=?',
                hideAddButton: '=?',
                showError: '=',
                openProduct: '&?',
                spAriaLive: '=?',
                onClick: '&?',
                showReplacementLabel: '=?',
                source: '@',
                index: '@',
                searchTerm: '=',
                resultsCount: '=',
                itemPosition: '=?',
                itemsCount: '=?',
                componentType: '=?',
                componentPosition: '=?',
                carouselName: '=?',
                specialId: '=?',
                homePageCarouselType: '@?',
                /** 1-based cart line position in list UI (Mixpanel); optional. */
                lineDisplayIndex: '<?'
            },
            controller: ['$scope', '$element', '$timeout', 'Cart', 'User', '$rootScope', 'Dialog', 'Util', 'Orders', 'SpDialogUrlManager', 'SP_SERVICES', function ($scope, $element, $timeout, cart, user, $rootScope, dialog, Util, Orders, SpDialogUrlManager, SP_SERVICES) {
                $scope.getLine = function () {
                    return $scope.line || util.getProductCartLine($scope.product, $scope.isCase);
                };

                _init();
                
                $scope.setFocus = function () {
                    $timeout(function () {
                        var focusElement = $element[0].querySelector('.sp-quantity button') || $element.parent()[0];
                        focusElement && focusElement.focus();
                    });
                };

                // $scope.replace = function (line, product, index) {
                //     if ($scope.hideAddButton) {
                //         $scope.openProduct(product, index);
                //     } else {
                //         $scope.addLine(line);
                //     }
                //     var line = util.getProductCartLine(product.oosProduct, $scope.isCase);
                //     console.log('ADD / REMOVE....');
                //     cart.removeLine(line, true);
                //     // console.log('DOING REPLACE ACTION....');
                //     // $rootScope.$emit('cart.product.replace', {
                //     //     product: product
                //     // })
                // };

                $scope.removeOOS = function(product) {
                    if (product.oosProduct) {
                        user.updateReplacementSuggestions([{
                            id: product.oosProduct.id,
                            suggestions: [{
                                id: product.id,
                                approved: true
                            }]
                        }]);

                        var line;
                        angular.forEach(cart.getLines(), function(cartLine) {
                            if (cartLine.product.id === product.oosProduct.id) {
                                line = cartLine;
                            }
                        });

                        if (!line) {
                            line = util.getProductCartLine(product.oosProduct, $scope.isCase);
                        }

                        if (!line) {
                            return;
                        }

                        $rootScope.cart.removeLine(line, true).then(function() {
                            if (product.oosProduct._suggestions && product.oosProduct._suggestions.length) {
                                angular.forEach(product.oosProduct._suggestions, function(product) {
                                    delete product.oosProduct;
                                });
                            }
                            // delete product.oosProduct;
                            !$rootScope.$$phase && $rootScope.$apply();

                            // support replace action for line with hide add button
                            if ((!$scope.getLine() || !$scope.getLine().quantity) && $scope.hideAddButton) {
                                dialog.hide({isConfirmed: false}).then(function() {
                                    util.openProduct(product, {searchTerm: $scope.searchTerm || undefined, resultsCount: $scope.resultsCount});
                                });
                            }
                            // if ($scope.onClick) {
                            //     $scope.onClick();
                            // }
                        })
                    }
                }

                $scope.addLine = function (line) {
                    if (Orders.orderInEdit && util.isCateringProduct(line)) {
                        SpDialogUrlManager.backClose();
                        return util.showCateringProductWarning();
                    }
                    
                    if ($scope.onClick) {
                        $scope.onClick();
                    }


                    if (line && line.product && line.product.productProperties && line.product.productProperties.length && !line.productPropertyValue && $scope.showError !== undefined) {
                        $scope.showError = true;
                        return;
                    }
                    var isLimitPassed = cart.checkHeavyLimitBeforeAddLine(line);
                    if (isLimitPassed === false) {

                        if (line.productPropertyValue && line.product.productProperties) {
                            line.productPropertyValue.propertyNames = line.product.productProperties[0].names;
                        }
                        
                        if (cart.lines && Object.keys(cart.lines).length === 0 &&
                            $rootScope.config.retailer.settings.includeDeliveryFeeInCart === 'true') {
                                cart.addDeliveryFeeLineIfNeeded();
                        }

                        if (line.product.oosProduct) {
                            var oosLine = util.getProductCartLine(line.product.oosProduct, $scope.isCase);
                            line.quantity = oosLine ? Math.ceil(oosLine.oldQuantity) : undefined;
                        }
                        var homePageCarouselType = line.homePageCarouselType ||
                            $scope.homePageCarouselType ||
                            ($scope.componentType != null
                                ? Util.getHomePageCarouselTypeName(Number($scope.componentType))
                                : undefined);
                        if ($scope.source) {
                            var sourceName = Util.extractHomeCarouselName($scope.source, $scope.componentType, $scope.componentPosition);
                            $scope.source = sourceName;
                        }
                        var params = {
                            source: $scope.source || line.source,
                            index: $scope.itemPosition || line.index,
                            searchTerm: $scope.searchTerm || undefined,
                            resultsCount: $scope.resultsCount,
                            componentType: $scope.componentType,
                            componentPosition: $scope.componentPosition,
                            itemsCount: $scope.itemsCount,
                            carouselName: $scope.carouselName,
                            specialId: $scope.specialId,
                            homePageCarouselType: homePageCarouselType
                        };
                        cart.addLine(line, line.product && line.product.soldBy, params).then(function(res) {
                            if((line.product && !line.product.singleLine) 
                                && (res && res.product && res.product.singleLine)
                            ) {
                                line.product.singleLine = res.product.singleLine;
                            }
                        });
                    }
                }

                function _init() {
                    _addClassToParentElement();
                }

                function _addClassToParentElement() {
                    setTimeout(function() {
                        var productActionsElement = $element[0];

                        if (!productActionsElement) {
                            return;
                        }

                        if ($rootScope.config.retailer.settings 
                            && $rootScope.config.retailer.settings.addToCartIcon 
                            && $rootScope.config.retailer.settings.addToCartIcon.isActive
                        ) {
                            productActionsElement.classList.add('new-add-to-cart-icon-container');
                        }
                    }, 0);
                }
            }]
        };
    }]);
})(angular, app);